import { environment } from '../../../../environments/environment'
import { type CartoClient } from '../../ooh/services/carto.helper'

export interface CampaignRow {
  id: number
  parent_id: number
  name: string
  type: string
  config: string
  start: string
  finish: string
  granularity: string
  territory: string
}

export async function fetchCampaigns(
  cartoClient: CartoClient,
  signal?: AbortSignal,
): Promise<CampaignRow[]> {
  const response = await cartoClient.query<CampaignRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_campaigns`,
    },
    params: {
      column: [
        'id',
        'parent_id',
        'name',
        'type',
        'config',
        'start',
        'finish',
        'granularity',
        'territory',
      ],
    },
    signal,
  })

  return response?.rows ?? []
}
